module.exports = __webpack_public_path__ + "assets/alertCircleFilled-831682.svg";